import { useCallback, useEffect, useState } from "react";

import httpclient from "../Utils";

export const useBay = () => {
  const [bays, setBays] = useState([]);
  const [loading, setLoading] = useState(false);

  const getBays = useCallback(async () => {
    setLoading(true);
    const API_URL = `/picker/bay-list`;

    try {
      const res = await httpclient.get(API_URL);
      const { data } = res;

      if (data.status === 200) {
        setBays(data.data);
      }
    } catch (error) {
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    getBays();
  }, [getBays]);

  return { bays, loading };
};
